import { render } from "./PlayAudienceView.vue?vue&type=template&id=65af70c1"
import script from "./PlayAudienceView.vue?vue&type=script&lang=js"
export * from "./PlayAudienceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/PlayAudienceView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65af70c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65af70c1', __exports__)) {
    api.reload('65af70c1', __exports__)
  }
  
  module.hot.accept("./PlayAudienceView.vue?vue&type=template&id=65af70c1", () => {
    api.rerender('65af70c1', render)
  })

}


export default __exports__